import axios from 'axios';

import { Log } from '../../helpers/CustomLogger';
import { getRandomUint64 } from '../../utils/getRandomUint64';

const randomNumber = getRandomUint64();

export const freeWheelApi = {
  trackSponsorLogo({ apiUrl, deviceId }: { apiUrl: string; deviceId: string }) {
    const params = {
      // eslint-disable-next-line camelcase
      _fw_vcid2: deviceId,
      pvrn: randomNumber,
      vprn: randomNumber,
    };

    axios
      .get(apiUrl, {
        params,
      })
      .catch((error: string) => {
        Log.error(error);
      });
  },
};
